import { LayoutPage } from '@/components/hoc';
import { TBreadcrumbProps } from '@/types';
import { UserRound } from 'lucide-react';
import { BodyPage } from './components';
import { useUser } from './hooks';
import routes from '@/lib/routes';

const UserPage = () => {

	const { userData } = useUser();

	const breadcrumb = (
		userData?.username
			? ({
				title: userData?.username,
				subMenus: [
					{
						tooltip: 'Liste des utilisateurs',
						href: routes.nav.users.getHref(),
						title: 'Utilisateurs'
					}
				]
			}) as TBreadcrumbProps
			: undefined
	);

	return (
		<LayoutPage
			breadcrumb={breadcrumb} 
			icon={UserRound}>
			<BodyPage />
		</LayoutPage>
	);

};

export default UserPage;
